import { useAccountForecast } from "../../hooks";

export const RenewalForecastPill = ({ renewalForecast }) => {
  const { getForecastStatusDisplay } = useAccountForecast();

  const forecastStatus = getForecastStatusDisplay(renewalForecast);

  return (
    <div
      className={`flex min-w-[100px] items-center justify-center rounded-lg px-2 py-1 ${forecastStatus.bgColor}`}
    >
      <div
        className={`text-center text-xs font-medium leading-none ${forecastStatus.textColor}`}
      >
        {forecastStatus.text}
      </div>
    </div>
  );
};
